import _ from 'lodash'
import Vue from 'vue'
import Settings from '@/config/Settings'

export default {

  namespaced: true,
  state: {
    initialized: false,
    game_status: Settings.game_status_initial,
    players: Settings.players,
    championship_game_status: {
      context: null, 
      score: { 
        home: 0,
        away: 0
      },
      position: null,
      time: 0,
    },
    on_continue: 0,
    users: {},
    already_connected: 0,
    database: null,
    championship: null,
    championship_data: null,
    championship_global_update: 0,
    championship_error: 0,
    ranking_updated: 0,
    schedule_updated: 0,
    reverse_user: 0,
    local_dispatch: null,
    added: null,
    already_added: null,
    duo_added: 0,
    duo_failled: 0,
    games: [],
    games_updated: 0,
    home_connected: false,
    away_connected: false,
    notify: null
  },
  mutations:{

    'LOCAL_DISPATCH'(state, data) {
      state.local_dispatch = data
    },
    'REVERSE_USER'(state) {
      state.game_status.ball = state.game_status.ball == 'home' ? 'away' : 'home'
      state.game_status.user = state.game_status.user == 'home' ? 'away' : 'home'
    },
    'GAME_ON_CONTINUE'(state) {
      state.on_continue += 1
    },
    'RESET_GAME_STATUS'(state) {
      state.game_status = Settings.game_status_initial
    },
    'RESTORE_GAME_STATUS'(state, data) {
      state.game_status = data
    },
    'UPDATE_GAME_STATUS'(state, data) {
      let obj = _.clone(state.game_status)
      _.each(data, (dt, index )=>{ 
        obj[index] = dt
      })

      state.game_status = obj
    },
    'UPDATE_PLAYERS'(state, data) {
      state.players = data
    },
    'UPDATE_NOTIFY'(state, data) {
      state.notify = data
    },
    'QUIT_GAME'(state) {
      state.initialized = false
    },
    'SOCKET_userConnected'(state, data) {
      state[data.user +'_connected'] = true
      state.users[data.user] = data.room
    },
    'SOCKET_setUserStatus'(state, data) {
      state.game_status = data.status;
      state.players = data.players
      state.initialized = true
    },
    'SOCKET_setUserPlayers'(state, status) {
      state.players = status
    },
    'SOCKET_userActionCompleted'(state, status) {
      state.game_status = status
    },
    'SOCKET_userPressContinue'(state) {
      state.on_continue += 1
    },
    'SOCKET_userLeaveRoom'(state, user) {
      state[user +'_connected'] = false
    },
    'SOCKET_alreadyConnected'(state) {
      state.already_connected += 1
    },
    'SOCKET_getDatabase'(state, data) {
      state.database = data
    },
    'SOCKET_usernameAdded'(state, res) {
      if(res == 'success') state.added = true
      else state.already_added = res
    },
    'SOCKET_proposerRequestCompleted' (state, res) {
      if(res == 'success') state.duo_added += 1
      else state.duo_failled += 1
    },
    'SOCKET_opponentInvitation'(state, name) {
      state.notify = name
    },
    'SOCKET_getUsers'(state, users) {
      //
    },
    'SOCKET_getNames'(state, names) {
      //
    },
    'SOCKET_getLiveGamesCompleted' (state, res) {
      state.games = res
      state.games_updated += 1
    },

    'SOCKET_getChampionship'(state, data) {
      state.championship_data = data
    },
    'SOCKET_errorChampionship'(state) {
      state.championship_error += 1
    },
    'SOCKET_createChampionshipCompleted'(state, id) {
      state.championship = id
    },
    'SOCKET_championshipGameStatus'(state, status) {
      state.championship_game_status = status
    },
    'SOCKET_championshipUpdate'(state, status) {
     
      let game_index = -1
      _.each(state.championship_data.games, (o, i)=>{
        if(o.room == status.game)
          game_index = i
      })  

      switch(status.context) {
        case 'GameLive': 
          if(game_index >= 0) {
            state.championship_data.games[game_index].live = true
            state.schedule_updated += 1
          }
          break
        case 'GameCompleted': 

          if(game_index >= 0) {
            state.championship_data.games[game_index].score = status.score
            state.championship_data.games[game_index].live = 'completed'
            if(status.score.home == status.score.away) {
              state.championship_data.ranking[status.opponents.home].n += 1
              state.championship_data.ranking[status.opponents.home].pts += 1
              state.championship_data.ranking[status.opponents.away].n += 1
              state.championship_data.ranking[status.opponents.away].pts += 1
            } 
            else if(status.score.home > status.score.away) {
              state.championship_data.ranking[status.opponents.home].w += 1
              state.championship_data.ranking[status.opponents.home].pts += 3
              state.championship_data.ranking[status.opponents.away].d += 1
            }
            else {
              state.championship_data.ranking[status.opponents.away].w += 1
              state.championship_data.ranking[status.opponents.away].pts += 3
              state.championship_data.ranking[status.opponents.home].d += 1
            }
            state.ranking_updated += 1
          }
          break
      }

    },
  },
  getters: {
    initialized: state => state.initialized,
    game_status: state => state.game_status,
    players: state => state.players,
    on_continue: state => state.on_continue,
    users: state => state.users,
    already_connected: state => state.already_connected,
    database: state => state.database,
    championship: state => state.championship,
    championship_data: state => state.championship_data,
    championship_game_status: state => state.championship_game_status,
    championship_global_update: state => state.championship_global_update,
    championship_error: state => state.championship_error,
    ranking_updated: state => state.ranking_updated,
    schedule_updated: state => state.schedule_updated,
    reverse_user: state => state.reverse_user,
    local_dispatch: state => state.local_dispatch,
    added: state => state.added,
    already_added: state => state.already_added,
    duo_added: state => state.duo_added,
    duo_failled: state => state.duo_failled, 
    games_updated: state => state.games_updated, 
    games: state => state.games, 
    home_connected: state => state.home_connected, 
    away_connected: state => state.away_connected, 
    notify: state => state.notify, 
  }
}


